export const getClassName = (...classNames: string[]) => classNames.join(' ');